import OccasionService from "../services/OccasionService";
import StoreRepository from "../repositories/StoreRepository";
import "../services/CourseService";
import ComparatorService from "../services/ComparatorService";
export default class OccasionManager {
    constructor(occasions, courseManager) {
        this._occasionService = new OccasionService();
        this._occasionRepository = new StoreRepository();
        this._repositories = [];
        this._comparatorService = new ComparatorService();
        this._repositories.push(courseManager.courseRepository);
        Object.keys(occasions).forEach(key => {
            let occasion = this._occasionService.mapInterfaceToModel(occasions[key], this._repositories);
            this._occasionRepository.storeItem(occasion);
        });
    }
    getOccasions(filter, day) {
        let store = this._occasionRepository.getStore();
        let array = [];
        Object.keys(store).forEach(key => {
            let occasion = store[key];
            let accepted = true;
            if (occasion.day !== day) {
                accepted = false;
            }
            if (filter.tutorSelectValue !== null && !occasion.course.tutorIDs.includes(filter.tutorSelectValue)) {
                accepted = false;
            }
            if (filter.roomSelectValue !== null && occasion.classroom !== filter.roomSelectValue) {
                accepted = false;
            }
            if (filter.timetableSelectValue !== null && !occasion.course.timetableIDS.includes(filter.timetableSelectValue)) {
                accepted = false;
            }
            if (filter.dateSelectValue !== null && !occasion.weekArray.includes(filter.dateSelectValue)) {
                accepted = false;
            }
            if (accepted) {
                array.push(occasion);
            }
        });
        return array;
    }
    getOccasionsTimeSorted(filter, day) {
        return this.getOccasions(filter, day).sort(this._comparatorService.compareByStartTime);
    }
    get occasionService() {
        return this._occasionService;
    }
    set occasionService(value) {
        this._occasionService = value;
    }
    get occasionRepository() {
        return this._occasionRepository;
    }
    set occasionRepository(value) {
        this._occasionRepository = value;
    }
    get repositories() {
        return this._repositories;
    }
    set repositories(value) {
        this._repositories = value;
    }
}
